import * as React from 'react';
import { connect } from 'react-redux';

import { Button } from 'reactstrap';

import {
    Tooltip
} from '@mui/material';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faRefresh, 
} from '@awesome.me/kit-8a0d2fd588/icons/modules/sharp/light';

import { ApplicationState } from '../../Store';
import { GetPortalText } from '../../Store/PortalAssets';
import { InlineStylingValues } from '../../Utils/Constants';

import { PortalTextCommon } from '../../Models/Api/strongbox.financialportal';

type InjectedReduxState = {
    commonText?: PortalTextCommon;
};

type InjectedActionCreators = {};

type RefreshButtonProps = {
    onClick: () => void;
    disabled?: boolean;
    style?: React.CSSProperties;
};

type Props = RefreshButtonProps & InjectedReduxState & InjectedActionCreators;

export const RefreshButtonComponent: React.FC<Props> = (props): React.ReactElement => {
    const {
        onClick,
        disabled,
        style,
        commonText,
    } = props;

    if (!commonText) {
        return (<></>);
    }

    return (
        <Tooltip title={(disabled === true) ? '' : (commonText?.refreshTooltip || '')}>
            <span>
                <Button
                    type={'button'}
                    className={'small'}
                    onClick={onClick}
                    disabled={disabled}
                    color="secondary"
                    style={style}
                >
                    <FontAwesomeIcon style={{ marginRight: InlineStylingValues.IconSeparator }} icon={faRefresh} />{commonText?.refresh || ''}
                </Button>
            </span>
        </Tooltip>
    );
}

export const RefreshButton = connect<InjectedReduxState, InjectedActionCreators, RefreshButtonProps, ApplicationState>(
    (appState: ApplicationState) => {
        const result: InjectedReduxState = {
            commonText: GetPortalText<PortalTextCommon>(appState, 'commonText'),
        };

        return result;
    }
)(RefreshButtonComponent);

